import { fromJS } from 'immutable'
import decamelize from 'decamelize'
import { ChartDataSources, ChartTypes } from './constants'

const facebookMetrics = [
  'pageViewsTotal',
  'pageFollows',
  'pageMediaView',
  'pageTotalMediaViewUnique',
  'pagePostEngagements',
  'pageDailyFollowsUnique',
  'pageDailyUnfollowsUnique'
]

const instagramMetrics = [
  'views',
  'reach',
  'totalInteractions',
  'accountsEngaged',
  'likes',
  'comments',
  'shares',
  'saves',
  'reposts',
  'replies',
  'followsAndUnfollows',
  'profileLinksTaps'
]

const buildMetrics = (metrics, instagram) => fromJS(metrics.map(metric => ({
  value: `${decamelize(metric)}_total`,
  instagram,
  chart: {
    firstLevel: metric,
    secondLevel: null,
    thirdLevel: null,
    dataSource: ChartDataSources.FACEBOOK_ANALYTICS,
    type: ChartTypes.RECTANGLE
  }
})))

const kpis = buildMetrics(facebookMetrics, false).concat(buildMetrics(instagramMetrics, true))

const config = fromJS([
  {
    value: 'page_views',
    instagram: false,
    chart: {
      firstLevel: 'timeline',
      secondLevel: null,
      thirdLevel: 'pageViewsTotal',
      dataSource: ChartDataSources.FACEBOOK_ANALYTICS,
      type: ChartTypes.AREA
    }
  },
  {
    value: 'page_follows',
    instagram: false,
    chart: {
      firstLevel: 'timeline',
      secondLevel: null,
      thirdLevel: 'pageFollows',
      dataSource: ChartDataSources.FACEBOOK_ANALYTICS,
      type: ChartTypes.AREA
    }
  },
  {
    value: 'page_media_view',
    instagram: false,
    chart: {
      firstLevel: 'timeline',
      secondLevel: null,
      thirdLevel: 'pageMediaView',
      dataSource: ChartDataSources.FACEBOOK_ANALYTICS,
      type: ChartTypes.AREA
    }
  },
  {
    value: 'page_total_media_view_unique',
    instagram: false,
    chart: {
      firstLevel: 'timeline',
      secondLevel: null,
      thirdLevel: 'pageTotalMediaViewUnique',
      dataSource: ChartDataSources.FACEBOOK_ANALYTICS,
      type: ChartTypes.AREA
    }
  },
  {
    value: 'page_post_engagements',
    instagram: false,
    chart: {
      firstLevel: 'timeline',
      secondLevel: null,
      thirdLevel: 'pagePostEngagements',
      dataSource: ChartDataSources.FACEBOOK_ANALYTICS,
      type: ChartTypes.AREA
    }
  },
  {
    value: 'page_daily_follows_unique',
    instagram: false,
    chart: {
      firstLevel: 'timeline',
      secondLevel: null,
      thirdLevel: 'pageDailyFollowsUnique',
      dataSource: ChartDataSources.FACEBOOK_ANALYTICS,
      type: ChartTypes.AREA
    }
  },
  {
    value: 'page_daily_unfollows_unique',
    instagram: false,
    chart: {
      firstLevel: 'timeline',
      secondLevel: null,
      thirdLevel: 'pageDailyUnfollowsUnique',
      dataSource: ChartDataSources.FACEBOOK_ANALYTICS,
      type: ChartTypes.AREA
    }
  },
  {
    value: 'page_video_views_by_paid_non_paid',
    instagram: false,
    chart: {
      firstLevel: 'timeline',
      secondLevel: 'videoViewTypes',
      thirdLevel: 'pageVideoViewsByPaidNonPaid',
      dataSource: ChartDataSources.FACEBOOK_ANALYTICS,
      type: ChartTypes.AREA
    }
  },
  {
    value: 'social_media_analytics_feed',
    instagram: false,
    chart: {
      firstLevel: 'socialMediaAnalyticsFeed',
      secondLevel: null,
      thirdLevel: null,
      dataSource: ChartDataSources.FACEBOOK_ANALYTICS,
      type: ChartTypes.SOCIAL_MEDIA_ANALYTICS_FEED
    }
  },
  {
    value: 'social_media_analytics_feed',
    instagram: true,
    chart: {
      firstLevel: 'socialMediaAnalyticsFeed',
      secondLevel: null,
      thirdLevel: null,
      dataSource: ChartDataSources.FACEBOOK_ANALYTICS,
      type: ChartTypes.SOCIAL_MEDIA_ANALYTICS_FEED
    }
  },
  {
    value: 'social_media_analytics_stories_feed',
    instagram: true,
    chart: {
      firstLevel: 'socialMediaAnalyticsStoriesFeed',
      secondLevel: null,
      thirdLevel: null,
      dataSource: ChartDataSources.FACEBOOK_ANALYTICS,
      type: ChartTypes.SOCIAL_MEDIA_ANALYTICS_STORIES_FEED
    }
  },
  {
    value: 'reach',
    instagram: true,
    chart: {
      firstLevel: 'timeline',
      secondLevel: null,
      thirdLevel: 'reach',
      dataSource: ChartDataSources.FACEBOOK_ANALYTICS,
      type: ChartTypes.AREA
    }
  }
]).concat(kpis)

export default config

export const findFirstChart = (instagram = false) => {
  const found = config.find(c => c.get('instagram') === instagram)

  if (found) {
    return found.get('value')
  }

  return null
}

export const findValueByChart = chart => {
  const found = config.find(c => fromJS({
    firstLevel: chart.get('firstLevel'),
    secondLevel: chart.get('secondLevel'),
    thirdLevel: chart.get('thirdLevel'),
    dataSource: chart.get('dataSource'),
    type: chart.get('type')
  }).equals(c.get('chart')))

  if (found) {
    return found.get('value')
  }

  return null
}
